// extracted by mini-css-extract-plugin
export default {"highlight":"bootstrap_highlight__1fEWq","title":"bootstrap_title__0IWzs","error":"bootstrap_error__ytEZP"};